import React from 'react'
import Img from 'gatsby-image'
// import SlideInRight from '../utility/slideInRightAnimation'
import Modal from './modal'

const ProductOnShow = props => (
  // <div className="section is-medium is-gradient">
  //   <div className="columns is-multiline">
  //     {props.intro && (
  //       <div className="column is-4 is-offset-4">
  //         <div className="container">
  //           <div className="content is-justified">
  //             <SlideInTop>
  //               <h4 className="is-white" style={{ lineHeight: 1.3 }}>
  //                 {props.intro}
  //               </h4>
  //             </SlideInTop>
  //           </div>
  //         </div>
  //       </div>
  //     )}
  //     <div className="column is-6 is-offset-3">
  //       <div className="container">
  // <SlideInRight>
  <div
    className="p-8 md:p-16 rounded-xl bg-white"
  >
    <div className="md:flex md:items-center md:space-x-16">
      <div className="md:w-1/3">
        {props.productImage && (
          <Img
            style={{
              position: `relative`,
              width: `${props.imageWidth}px`,
              // height: `${props.imageWidth / 2.692}px`,
              // right: '58px',
            }}
            fixed={props.productImage}
            alt={props.productImageAlt}
          />
        )}
        </div>
        <div className="text-center md:text-left">
          <h2 className='font-semibold text-2xl'>{props.productTitle}</h2>
          <p className="py-4">{props.productDescription}</p>
          {props.features && (
            <table className="table is-bordered is-striped is-narrow is-hoverable w-full">
              <tbody>
                {props.features.map((feature, idx) => (
                  <tr>
                    <th>
                      <small>{props.featureTitle[idx]}</small>
                    </th>
                    <td>
                      <small>{props.featureDesc[idx]}</small>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <div className="flex">
              <Modal
                component={props.formInfo}
                buttonLabel={props.productInfoCTA}
                buttonClass="is-info is-medium is-fullwidth"
              />
        </div>
      </div>
    </div>
  </div>
  // </SlideInRight>
  //       </div>
  //     </div>
  //   </div>
  // </div>
)

export default ProductOnShow
